<template>
    <div class="layout__padding-clear layout__width-100">

        <!--todo maybe add pagination to the search but will have to make an additional call for the csv download-->

        <!--{{this.finalQuery}}<br>-->
        <!--&lt;!&ndash;{{this.customers[0]}}&ndash;&gt;-->



        <!--{{this.parameters}}-->
        <!--<br>-->
        <!--{{this.searchParams}}<br>-->
        <!--{{this.freetextQueryOptions}}-->

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">
            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Search</p>
                    <el-form-item prop="freetext">
                        <el-input placeholder="Search" v-model="searchParams.freetext"
                                  clearable
                                  autofocus></el-input>
                    </el-form-item>
                </div>
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Status</p>
                    <el-form ref="status">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.status" placeholder="Order Status" clearable>
                                <el-option v-for="status in ravensworth.customerStatus.options"
                                           :key="status.id"
                                           :label="status.name"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>
        <div class="layout__display-block layout__width-100">
            <el-button class="button-red layout__position-center button__base layout__width-150px" id="getCustomers" v-on:click="getOrders('searchParams')">Search Customers
            </el-button>
        </div>

        <el-button class="layout__display-none" id="getCustomersPagination" v-on:click="getCustomersPagination()">Search Customers
        </el-button>

        <el-button :disabled="this.$parent.customers.length === 0" class="button-teal layout__position-right button__base__admin layout__width-200px" id="downloadAllResults" :loading="downloadLoading" v-on:click="downloadAllResults()">Download Data (csv)
        </el-button>

        <div class=" layout__position-right layout__padding-5-10">
            <p>{{this.resultsCount}} Results Found</p>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "adminCustomerSearch",
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            searchParams: Object,
            customers: Array,
            loading: Boolean,
            resultsCount: String
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                downloadLoading: false,
                freetextQueryOptions: [],
                resourcePath: '/odata/CustomerSearch',
                queryRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/adminSearchcustomers?`,
                parameters: [],
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                finalQuery: '',
                territories: [],
                users: [],
                exportDate: new Date().toLocaleDateString('en-GB') + '_customers.csv'
            }
        },
        created() {
            this.isUserAuthorised();

            if (window.sessionStorage.getItem('_customersSearch') !== null && typeof window.sessionStorage.getItem('_customersSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_customersSearch'))
            } else {
                console.log('not pulling from getItem')
            }

            this.getResults()

            // todo the search works orders pages spec out initial search criteria and pass into here with orders array and the parent gets updated with the results
        },
        methods: {
            constructQueryString() {

                this.queryOptions = []
                this.freetextQueryOptions = []
                this.parameters = []

                let searchTerms = Object.assign({}, this.$parent.searchParams)

                let baseQueryUri = this.serviceRouteUrl + this.resourcePath

                // this.finalQuery = ''
                //
                if (searchTerms.freetext !== '') {
                    // this.freetextQueryOptions.push('contains(ref, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(parentRef, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(status, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(type, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(customerName, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(branchName, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(town, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(postcode, \'' + searchTerms.freetext + '\')')
                    // this.freetextQueryOptions.push('contains(brand, \'' + searchTerms.freetext + '\')')
                    this.parameters.push('freetext=' + searchTerms.freetext)
                }

                console.log('status of customers')
                console.log(searchTerms.status)
                console.log(searchTerms.status !== '' || searchTerms.status !== null)

                if (searchTerms.status !== null && searchTerms.status !== '' && searchTerms.status !== 'ANY STATUS') {
                    this.parameters.push('status=' + searchTerms.status)
                }
                // } else if (searchTerms.status === 'ANY STATUS') {
                //     this.parameters.push('status=' + '*')
                // }

                // if (searchTerms.freetext !== '') {
                //     console.log('not equals null')
                //     this.finalQuery = baseQueryUri.concat('?$filter=', '(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.queryConcatAnd, this.queryOptions.join(this.queryConcatAnd))
                // } else if (searchTerms.status !== null && searchTerms.status !== 'ANY STATUS') {
                //     this.finalQuery = baseQueryUri.concat('?$filter=', this.queryOptions.join(this.queryConcatAnd))
                // } else {
                //     this.finalQuery = baseQueryUri.concat('?')
                // }


                console.log(this.finalQuery)


                console.log(this.finalQuery.concat('&count=true'))

                console.log('FINISHED METHOD')
            },
            getResults() {

                this.finalQuery = ''

                this.constructQueryString()
                let getResults = '';


                if (this.parameters.length != 0) {
                    getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + this.$parent.searchParams.skip + '&top=' + this.$parent.searchParams.top + '&additional=true'
                    console.log('results')
                    console.log(getResults)
                } else {
                    getResults = this.queryRouteUrl + 'skip=' + this.$parent.searchParams.skip + '&top=' + this.$parent.searchParams.top
                    console.log('results')
                    console.log(getResults)
                }

                this.$parent.loading = true

                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.customers = []
                        this.$parent.customers = response.data.value

                        console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        this.$parent.customers = []
                        // }
                    })

                let getCounts = '';


                if (this.parameters.length != 0) {
                    getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0&additional=true'
                    console.log('count')
                    console.log(getCounts)
                } else {
                    getCounts = this.queryRouteUrl + 'count=true&top=0'
                    console.log('count')
                    console.log(getCounts)
                }

                // this.$parent.loading = true // todo this might be an issue with the true and false
                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']

                        // console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        // }
                    })
            },
            downloadAllResults() {
                this.downloadLoading = true

                this.constructQueryString()
                // this.$parent.loading = true

                const downloadAllResultsUri = this.queryRouteUrl + this.parameters.join('&') + '&additional=true'

                console.log(downloadAllResultsUri)

                Axios.get(downloadAllResultsUri, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)

                        const fields = [
                            {label: 'Id', value: 'id'},
                            {label: 'Branch', value: 'ref'},
                            {label: 'Head_Office', value: 'parentRef'},
                            {label: 'Netsuite_Id', value: 'netsuiteId'},
                            {label: 'Status', value: 'status'},
                            {label: 'Type', value: 'type'},
                            {label: 'Customer', value: 'customerName'},
                            {label: 'Branch_Name', value: 'branchName'},
                            {label: 'Branch Telephone', value: 'telNo'},
                            {label: 'Address1', value: 'address1'},
                            {label: 'Address2', value: 'address2'},
                            {label: 'Address3', value: 'address3'},
                            {label: 'Town', value: 'town'},
                            {label: 'County', value: 'county'},
                            {label: 'Postcode', value: 'postcode'},
                            {label: 'DX', value: 'box'},
                            {label: 'Print_Profile', value: 'printProfile'},
                            {label: 'Territory', value: 'territory'},
                            {label: 'Brand', value: 'brand'},
                            {label: 'Software', value: 'software'},
                            {label: 'Decision_Marker_Name', value: 'marketingContact'},
                            {label: 'Decision_Marker_Email', value: 'marketingEmail'},
                            {label: 'Sales_Contact_Name', value: 'salesContact'},
                            {label: 'Sales_Contact_Email', value: 'salesEmail'},
                            {label: 'General_Email', value: 'email'},
                            {label: 'Accounts_Email', value: 'accountsEmail'},
                            {label: 'Vat_Rate', value: 'vatRate'},
                            {label: 'Invoice_Flag', value: 'invoiceFlag'},
                            {label: 'Sage_Status', value: 'sageStatus'},
                            {label: 'Last_Order', value: (row, field) => this.formatLastOrderedDate(row)},
                        ];

                        this.downloadCsv(this.exportDate, fields, response.data.value)

                        this.downloadLoading = false
                    })
                    .catch(error => {
                        // this.$parent.loading = false

                        // const errorList = ['Unable to process download'];
                        // return errorList;
                        // if (error.response.status === 500) {
                        // this.$parent.customers = []
                        // }
                    })
            },
            getOrders(searchParams) {
                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.getResults()
                    } else {
                        return false;
                    }
                })
            },
            getCustomersPagination() {
                this.getResults()
            }
        }
    };
</script>